<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper dashboard-wrapper">
            <!-- Main content -->
            <section class="content">
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
  import Vue from 'Vue'
  import VueCookie from 'vue-cookie'
  Vue.use(VueCookie)

  export default {
    name: 'dashboard-empty',
    mounted () {
      if (localStorage.session === null || localStorage.session === '' || localStorage.session === false) {
        this.$router.push('/login')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// DashboardEmpty.vue?3c7badca